export function orderHasChanged(
  original: { dateModified: string; status: string; orderJson: string },
  current: { dateModified: string; status: string; orderJson: string },
): boolean {
  return original.dateModified !== current.dateModified
    || original.status !== current.status
    || original.orderJson !== current.orderJson
}
